import PageTop from "@/components/PageTop";
import { trackSignUp } from "@/lib/tracking";
import { cn } from "@/lib/utils";

interface HeroProps {
  headline?: React.ReactNode;
  description?: React.ReactNode;
  centered?: boolean;
  Icon?: React.ComponentType<{ className?: string }>;
  iconClassName?: string;
}

const Hero = ({
  headline = (
    <>
      Know every account.
      <br />
      Grow every account.
    </>
  ),
  description = "Finally know what every customer is doing — and what to do about it.",
  centered = true,
  Icon,
  iconClassName,
}: HeroProps) => {
  // The icon sits in the text flow, so a wrapping headline moves the words to
  // the next line while the icon keeps its place at the start.
  const title = Icon ? (
    <span>
      <Icon
        className={cn("inline h-[1em] w-[1em] align-[-0.125em] mr-3", iconClassName)}
      />
      {headline}
    </span>
  ) : (
    headline
  );

  if (centered) {
    return (
      <PageTop>
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-8 md:gap-10">
          <h1
            className="text-5xl md:text-7xl leading-[1.1] tracking-tight"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {title}
          </h1>
          <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
            {description}
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://eu.bigdelta.com/sign-up"
              onClick={trackSignUp}
              className="bg-foreground text-background px-6 py-3 rounded-full text-sm font-medium hover:bg-foreground/90 transition-colors"
            >
              Start free
            </a>
          </div>
        </div>
      </PageTop>
    );
  }

  return (
    <PageTop>
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 md:gap-28 items-start">
        <div className="flex flex-col gap-8 md:gap-10">
          <h1
            className="text-5xl md:text-7xl leading-[1.1] tracking-tight"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {title}
          </h1>
          <div className="flex items-center gap-3">
            <a
              href="https://eu.bigdelta.com/sign-up"
              onClick={trackSignUp}
              className="bg-foreground text-background px-6 py-3 rounded-full text-sm font-medium hover:bg-foreground/90 transition-colors"
            >
              Start free
            </a>
          </div>
        </div>
        <div className="md:pt-4">
          <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-md">
            {description}
          </p>
        </div>
      </div>
    </PageTop>
  );
};

export default Hero;
